import { config } from '../config/config';

// Interface pour les détails de paiement My-CoolPay
export interface MyCoolPayPaymentDetails {
  amount: number;
  votes_count: number;
  phoneNumber: string;
  operator: string;
  contestantId: string;
  description: string;
  customerName?: string;
  customerEmail?: string;
}

// Interface pour la réponse d'initiation de paiement My-CoolPay
export interface MyCoolPayPaymentResponse {
  success: boolean;
  transaction_id: string;
  payment_url: string;
  amount: number;
  votes: number;
}

// Interface pour la réponse de statut My-CoolPay
export interface MyCoolPayStatusResponse {
  success: boolean;
  status: 'pending' | 'completed' | 'failed';
  transaction_id: string;
  amount: number;
  votes: number;
}

/**
 * Initie un paiement via la fonction Edge My-CoolPay
 */
export const initiateMyCoolPayEdgePayment = async (
  details: MyCoolPayPaymentDetails
): Promise<MyCoolPayPaymentResponse> => {
  try {
    console.log('Envoi des données à My-CoolPay:', JSON.stringify(details));
    
    const response = await fetch(`${config.supabaseUrl}/functions/v1/mycoolpay-proxy/initiate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${config.supabaseKey}`
      },
      body: JSON.stringify(details)
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch (e) {
        errorData = { text: errorText };
      }
      console.error('Réponse d\'erreur de la fonction Edge:', errorData);
      throw new Error(errorData.error || 'Erreur lors de l\'initiation du paiement My-CoolPay');
    }

    const responseData = await response.json();
    console.log('Réponse de la fonction Edge:', responseData);
    return responseData;
  } catch (error) {
    console.error("Erreur lors de l'initiation du paiement My-CoolPay:", error);
    throw error;
  }
};

/**
 * Vérifie le statut d'un paiement via la fonction Edge My-CoolPay
 */
export const checkMyCoolPayEdgePaymentStatus = async (
  transaction_id: string
): Promise<MyCoolPayStatusResponse> => {
  try {
    const response = await fetch(`${config.supabaseUrl}/functions/v1/mycoolpay-proxy/status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${config.supabaseKey}`
      },
      body: JSON.stringify({ transaction_id })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la vérification du statut My-CoolPay');
    }

    return await response.json();
  } catch (error) {
    console.error("Erreur lors de la vérification du statut My-CoolPay:", error);
    throw error;
  }
};
